import { render, staticRenderFns } from "./yxcx.vue?vue&type=template&id=7e96562d&scoped=true&"
import script from "./yxcx.vue?vue&type=script&lang=js&"
export * from "./yxcx.vue?vue&type=script&lang=js&"
import style0 from "./yxcx.vue?vue&type=style&index=0&id=7e96562d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e96562d",
  null
  
)

export default component.exports